import { Box, Dialog, Typography } from '@mui/material';
import CustomButton from 'common-components/Button';

export type ConfirmationDialogProps = {
  open: boolean;
  onClose?: () => void;
  onConfirm?: () => void;
  title?: string;
  message: string;
  confirmButtonTitle?: string;
  cancelButtonTitle?: string;
  // Customization props
  icon?: React.ReactNode;
  titleColor?: string;
  messageColor?: string;
  buttonColor?: string;
  buttonHoverColor?: string;
  dismissable?: boolean;
  buttonType ?: 'single' | 'double';
};

const sxStyles = {
  dialogPaper: {
    borderRadius: '10px',
    padding: '20px',
  },
  title: {
    fontSize: '24px',
    fontWeight: '500',
  },
  message: {
    fontSize: '16px',
    textAlign: 'center' as const,
  },
  iconWrapper: {
    width: '60px',
    height: '60px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 16px',
  },
};

const ConfirmationDialog = (props: ConfirmationDialogProps) => {
  const {
    open,
    onClose,
    onConfirm,
    title = 'Confirm Action',
    message,
    confirmButtonTitle = 'Okay',
    cancelButtonTitle = 'Cancel',
    icon,
    titleColor = '#1982BB',
    messageColor = '#757575',
    buttonColor = '#1982BB',
    buttonHoverColor = '#0d5a96',
    dismissable = false,
    buttonType = 'single',
  } = props;

  return (
    <Dialog
      open={open}
      onClose={() => {
        if (!dismissable) return;
        onClose?.();
      }}
      fullWidth
      maxWidth="sm"
      slotProps={{ paper: { sx: sxStyles.dialogPaper } }}
    >
      <Box className="confirmation-root" sx={{ textAlign: 'center', py: 2 }}>
        {/* Icon */}
        {icon && (
          <Box
            sx={{
              ...sxStyles.iconWrapper,
              backgroundColor: `${buttonColor}15`,
            }}
          >
            {icon}
          </Box>
        )}

        {/* Title */}
        <Typography sx={{ ...sxStyles.title, color: titleColor, mb: 1 }}>
          {title}
        </Typography>

        {/* Message */}
        <Typography sx={{ ...sxStyles.message, color: messageColor, mb: 3 }}>
          {message}
        </Typography>

        {/* Buttons */}
        <Box sx={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
          <CustomButton
            title={confirmButtonTitle}
            sx={{
              backgroundColor: buttonColor,
              color: '#fff',
              '&:hover': {
                backgroundColor: buttonHoverColor,
              },
            }}
            onClick={onConfirm}
          />
          {buttonType === 'double' && <CustomButton
            title={cancelButtonTitle}
            isActive={false}
            onClick={onClose}
          />}
        </Box>
      </Box>
    </Dialog>
  );
};

export default ConfirmationDialog;
